"use client";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Slide from "@mui/material/Slide";
import { Backdrop, Button, Collapse, Container, Grid, Link } from "@mui/material";

import AvatarLogin from "@/app/_components/AvatarLogin";
import NextLink from "next/link";
import HeaderCartButton from "./HeaderCartButton";
import { useBreakPoints } from "@/lib/useBreakPoints";
import Image from "next/image";
import SearchInput from "./SearchInput";
import Category2Icon from "@/app/_components/Icons/Category2Icon";
import NavbarCategories from "./NavbarCategories";
import NetworkCheckStatus from "@/app/_components/NetworkCheckStatus";
import React from "react";
import { motion } from "framer-motion";

export default function SiteHeader() {
  const trigger = useScrollTrigger();
  const { mdAndDown } = useBreakPoints();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <>
      <NetworkCheckStatus />
      <Backdrop sx={(theme) => ({ color: "#fff", zIndex: 2 })} open={open} onClick={handleClose}></Backdrop>

      <AppBar
        elevation={0}
        sx={{
          zIndex: 3,
          color: "grey.800",
          backgroundColor: "background.default",
          borderBottom: "1px solid",
          borderBottomColor: "transparent",
          ...(trigger && {
            borderBottomColor: "grey.200",
          }),
        }}
      >
        {/* <Container
          maxWidth={"xl"}
          sx={{
            transition: "0.2s all ease-in",
            backgroundColor: "background.default",
            zIndex: 2,
            py: { xs: trigger ? 0.5 : 1, md: !trigger ? 1.5 : 1 },
          }}
        ></Container> */}
        <Container
          maxWidth={"xl"}
          sx={{
            transition: "0.2s all ease-in",
            backgroundColor: "background.default",
            zIndex: 2,
            py: { xs: 0.5, md: 1 },
            // py: { xs: trigger ? 0.5 : 1, md: !trigger ? 1.5 : 1 },
          }}
        >
          <Toolbar disableGutters sx={{ transition: "0.2s all" }}>
            <Grid container spacing={3} alignItems={"center"} wrap={"nowrap"} display={"flex"} flexWrap={"nowrap"}>
              <Grid item xs={"auto"} sm={"auto"} md={"auto"}>
                <Link component={NextLink} href={"/"} underline={"none"} color={"inherit"} variant={"h3"}>
                  <Box
                    sx={{
                      transition: "0.2s all ease-in",
                      width: { xs: 70, md: 115 },
                      height: { xs: 40, md: 48 },
                      position: "relative",
                    }}
                  >
                    <Image fill src={"/logo.svg"} style={{ objectFit: "contain" }} alt="Zibasi Logo" />
                  </Box>
                </Link>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <SearchInput open={open} onOpen={handleOpen} onClose={handleClose} />
              </Grid>
              <Grid item sx={{ ml: "auto", display: { xs: "none", md: "flex" } }} flexWrap={"nowrap"} gap={2}>
                <AvatarLogin />
                <HeaderCartButton />
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
        <Collapse sx={{}} in={!trigger} >
          <Toolbar
            variant="dense"
            sx={{
              // zIndex: 1,
              backgroundColor: "background.default",
              borderBottom: "1px solid",
              borderBottomColor: "transparent",
              ...(!trigger && {
                borderBottomColor: "grey.200",
              }),
              display: { xs: "none", md: "flex" },

              // pt: 0.5,
              // minHeight: "unset",
            }}
          >
            <Container maxWidth={"xl"} sx={{ display: "flex", gap: 2, alignItems: "center", pb: 0.7 }}>
              {/* <MegaMenu /> */}
              <Link component={NextLink} href={"/products"} underline={"none"} color={"inherit"}>
                <Typography
                  variant="subtitle1"
                  whiteSpace={"nowrap"}
                  sx={{ color: "grey.800", display: "flex", alignItems: "center", gap: 1 }}
                >
                  <Category2Icon />
                  <span> دسته بندی محصولات</span>
                </Typography>
              </Link>

              <NavbarCategories />
              <Button
                component={NextLink}
                href="/products"
                variant="outlined"
                color="secondary"
                sx={{ borderRadius: 60, whiteSpace: "nowrap" }}
                // endIcon={<ArrowLeftIcon   />}
              >
                🔥 محصولات پیشنهادی
              </Button>
            </Container>
          </Toolbar>
        </Collapse>
        {/* <Box
          sx={{ display: { xs: "none", md: "flex" }, width: "100%" }}
          component={motion.section}
          animate={{ y: trigger ? -60 : 0, height: trigger ? "0px" : "auto" }}
        >
     
        </Box> */}
        {/* <Slide style={{ zIndex: 1 }} appear={false} direction="down" in={!trigger}>
      
        </Slide> */}
      </AppBar>
      <Toolbar sx={{ minHeight: { xs: 64, sm: 84, md: 140 } }} />
    </>
  );
}
